export const API_URL =  "https://admin.talkspro.co/api/v1";
export const TOKEN_PREFIX = 'Bearer ';
export const VERSION_SESSION = '2';
